module.exports = __webpack_public_path__ + "img/3.ce0ff985.png";